import React from 'react'
import AboutHeader from '../../components/Doctors/AboutHeader'
export default function AbouPage() {
  return (
    <div>
      <AboutHeader/>
    </div>
  )
}
